import { getReportParams, report } from 'app/middleware/report';
export function dwhCouponHistoryPageDisplayed({ contact, loginType, sourceUrl, customerName, idNumber, subscriber }) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'PersonalCoupons';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'My Coupons Page';
  reportParams.status = 'Ongoing';
  reportParams.messageText = 'My Coupons Page Displayed';
  reportParams.param9 = contact;
  reportParams.param10 = loginType;
  reportParams.sourceURL = sourceUrl;
  reportParams.customerName = customerName;
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  report(reportParams);
}

export function dwhResendCouponSuccessReport({contact, loginType, sourceUrl, customerName, idNumber, subscriber }) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'PersonalCoupons';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Resend Coupon';
  reportParams.status = 'Completed';
  reportParams.messageText = 'Resend Coupon Success';
  reportParams.param9 = contact;
  reportParams.param10 = loginType;
  reportParams.sourceURL = sourceUrl;
  reportParams.customerName = customerName;
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  report(reportParams);
}
export function dwhResendCouponErrorReport({contact, loginType, sourceUrl, customerName, idNumber, subscriber }) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'PersonalCoupons';
  reportParams.channel = 'WebsitePrivate';
  reportParams.actionType = 'Resend Coupon Error';
  reportParams.status = 'Error';
  reportParams.messageText = 'Resend Coupon Error';
  reportParams.param9 = contact;
  reportParams.param10 = loginType;
  reportParams.sourceURL = sourceUrl;
  reportParams.customerName = customerName;
  reportParams.idNumber = idNumber;
  reportParams.subscriber = subscriber;
  report(reportParams);
}
